import Vue from 'vue';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.use(axios);
Vue.prototype.$axios = axios

// 网站样式引用
import '@/assets/css/style.less';
// 适配css
import '@/assets/css/adapter.less';
// 引用公共js文件
import common from '@/assets/js/common';
Vue.use(common);

// vant移动端组件库 文档地址：https://youzan.github.io/vant/#/zh-CN/home
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// vue版整屏滚动组件 github地址：https://github.com/yokiyokiyoki/vue-fullpage
import VueFullpage from 'vue-fullpage.js'
Vue.use(VueFullpage)

// vue版手势组件 文档地址：https://blog.csdn.net/weixin_43294560/article/details/107814708
import vuetouch from 'vue-touch'
Vue.use(vuetouch, {name: 'v-touch'})

//swipe高级滚动组件 文档地址：https://github.com/surmon-china/vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

// animate动画库 文档地址：https://animate.style/
import animated from 'animate.css'
Vue.use(animated)

// echart组件库 文档地址：https://www.makeapie.com/
import * as echarts from 'echarts';
import 'echarts/map/js/china.js'
Vue.use(echarts)
Vue.prototype.$echarts = echarts

// 引入request组件
// import request from 'qdqts-request'
// Vue.use(request)

// 手指左右滑动距离
vuetouch.config.swipe = {
  threshold: 50

}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')